import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
    brand_name: "JnS Creation",
    brand_tagline: "Handpicked Boutique",
    contact_email: "admin.jns.creation@gmail.com",
    contact_phone: "+91 73597 92437",
    whatsapp_number: "917359792437",
    instagram_handle: "jns.creation.ds",
    free_delivery_threshold: 2000,
    delivery_fee: 100,
};

const SettingsContext = createContext(DEFAULTS);

export const SettingsProvider = ({ children }) => {
    const [s, setS] = useState(DEFAULTS);
    useEffect(() => {
        // Jul 2026 — this was a single-shot fetch: one transient network
        // failure silently dropped every settings-driven section (Instagram
        // grid, thresholds, contact details) for the entire session. Two
        // quiet retries with backoff make the boot resilient, no UI change.
        let alive = true;
        const load = (attempt = 0) => {
            axios.get(`${API}/settings/public`)
                .then((r) => { if (alive) setS((prev) => ({ ...prev, ...r.data })); })
                .catch(() => {
                    if (alive && attempt < 2) setTimeout(() => load(attempt + 1), 1500 * (attempt + 1));
                });
        };
        load();
        return () => { alive = false; };
    }, []);
    return <SettingsContext.Provider value={s}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
